import { Task } from 'types/types';
import { Mode } from './types';
export const getDatesBetweenDates = (
  startDate: Date,
  endDate: Date
): Date[] => {
  let dates: Date[] = [];
  const theDate = new Date(startDate);
  while (theDate <= endDate) {
    dates = [...dates, new Date(theDate)];
    theDate.setDate(theDate.getDate() + 1);
  }
  return dates;
};

export const parseYMD = (value: string, separator: string): Date => {
  const date = value.split(separator);
  const y = parseInt(date[0], 10);
  const m = parseInt(date[1], 10);
  const d = parseInt(date[2], 10);
  return new Date(y, m - 1, d);
};

export const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const filterExceptionTasks = (allTasks: Task[]): Task[] => {
  const exceptionTasks = allTasks.filter((task) => task.state === 3);
  const uniqueTasksMap = new Map();

  exceptionTasks.forEach((task) => {
    const key = `${task.name}-${task.cron_start_day}-${task.cron_end_date}`;
    if (!uniqueTasksMap.has(key)) {
      uniqueTasksMap.set(key, task);
    }
  });

  return Array.from(uniqueTasksMap.values());
};

export const getUnavailableDatesPeriodes = (allTasks: Task[]): Date[] => {
  const exceptionTasks = allTasks.filter((task) => task.state === 3);
  const dates: Date[] = [];

  exceptionTasks.forEach((exceptionTask) => {
    if (!exceptionTask.cron_start_day || !exceptionTask.cron_end_date) return;

    const dateStartString = exceptionTask.cron_start_day;
    const dateEndString = exceptionTask.cron_end_date;
    const dateStartParts = dateStartString.split('-');
    const dateEndParts = dateEndString.split('-');

    const debut = new Date(
      +dateStartParts[2],
      parseInt(dateStartParts[1]) - 1,
      +dateStartParts[0]
    );
    const fin = new Date(
      +dateEndParts[2],
      parseInt(dateEndParts[1]) - 1,
      +dateEndParts[0]
    );

    for (let d = debut; d <= fin; d.setDate(d.getDate() + 1)) {
      dates.push(new Date(d));
    }
  });

  return dates;
};

export const buildTimelineMatrixFromTasks = (
  tasks: Task[],
  modes: Mode[],
  colorsArrayElectrovanne: string[],
  colorsArrayBaseVie: string[],
  viewType: number
) => {
  const newMarkerMatrix: number[][] = Array.from({ length: 7 }, () => []);
  const newTimelineMatrix: Mode[][] = Array.from({ length: 7 }, () =>
    Array.from({ length: 48 }, () => modes[0])
  );
  const dayModes: { [key: string]: { [key: number]: Mode } } = {};

  tasks.forEach((task: any) => {
    if (task.state === 2 || task.state === 3) return;
    let dayIndex = JSON.parse(task.cron_day_of_week!);
    dayIndex = dayIndex === 6 ? 0 : dayIndex + 1;
    const hour = parseInt(task.cron_hour!, 10);
    const minute = parseInt(task.cron_minute!, 10);
    const marker = hour * 2 + (minute === 30 ? 1 : 0);

    if (!dayModes[dayIndex]) {
      dayModes[dayIndex] = {};
    }
    const mode =
      modes.find(
        (mode: any) =>
          '' + mode.id ===
          ((task.id_arguments && task.id_arguments[0]?.Value) || '')
      ) || modes[0];
    dayModes[dayIndex][marker] = mode;

    if (!newMarkerMatrix[dayIndex].includes(marker)) {
      newMarkerMatrix[dayIndex].push(marker);
    }
  });

  Object.entries(dayModes).forEach(([dayIndex, markers]) => {
    const dayIndexNum = parseInt(dayIndex);
    const sortedMarkers = Object.keys(markers)
      .map(Number)
      .sort((a, b) => a - b);

    for (let i = 0; i < 48; i++) {
      const lastMarker = sortedMarkers.filter((marker) => marker <= i).pop();

      if (lastMarker !== undefined) {
        newTimelineMatrix[dayIndexNum][i] = markers[lastMarker];
      }
    }
  });

  return { newMarkerMatrix, newTimelineMatrix };
};
